var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { SpecificationHelpers } from '../../helpers';
import { defaultConfig } from '../../config';
import AsyncApiLayout from './Layout';
import { Error } from '../Error/Error';
import { PluginManager } from '../../helpers/pluginManager';
import { PLUGINEVENTS } from '../../constants';
var AsyncApiComponent = (function (_super) {
    __extends(AsyncApiComponent, _super);
    function AsyncApiComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.registeredPlugins = new Set();
        _this.propsPlugins = new Set();
        _this.state = {
            asyncapi: undefined,
            error: undefined,
            pm: new PluginManager({
                schema: {},
            }),
        };
        var parsedSpec = SpecificationHelpers.retrieveParsedSpec(props.schema);
        if (parsedSpec) {
            _this.state = { asyncapi: parsedSpec };
        }
        return _this;
    }
    AsyncApiComponent.prototype.componentDidMount = function () {
        if (!this.state.asyncapi) {
            this.updateState(this.props.schema);
        }
        if (this.props.onPluginManagerReady) {
            this.props.onPluginManagerReady(this.state.pm);
        }
        this.setupEventListeners();
        this.registerPlugins();
    };
    AsyncApiComponent.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, schema = _a.schema, plugins = _a.plugins, onPluginEvent = _a.onPluginEvent;
        var oldSchema = prevProps.schema;
        var newSchema = schema;
        if (oldSchema !== newSchema) {
            this.updateState(newSchema);
        }
        if (onPluginEvent !== prevProps.onPluginEvent) {
            this.cleanupEventListeners();
            this.setupEventListeners();
        }
        if (plugins !== prevProps.plugins) {
            this.updatePlugins(prevProps.plugins, plugins);
        }
    };
    AsyncApiComponent.prototype.render = function () {
        var _a;
        var _b = this.props, config = _b.config, propError = _b.error;
        var _c = this.state, asyncapi = _c.asyncapi, stateError = _c.error, pm = _c.pm;
        var error = propError !== null && propError !== void 0 ? propError : stateError;
        var concatenatedConfig = __assign(__assign(__assign({}, defaultConfig), config), { show: __assign(__assign({}, defaultConfig.show), (!!config && config.show)), expand: __assign(__assign({}, defaultConfig.expand), (!!config && config.expand)), sidebar: __assign(__assign({}, defaultConfig.sidebar), (!!config && config.sidebar)), extensions: __assign(__assign({}, defaultConfig.extensions), (!!config && config.extensions)) });
        if (!asyncapi) {
            if (!error) {
                return null;
            }
            return (((_a = concatenatedConfig.show) === null || _a === void 0 ? void 0 : _a.errors) && (React.createElement("section", { className: "aui-root" },
                React.createElement(Error, { error: error }))));
        }
        return (React.createElement(AsyncApiLayout, { asyncapi: asyncapi, config: concatenatedConfig, pluginManager: pm }));
    };
    AsyncApiComponent.prototype.handler = function (eventName) {
        var _this = this;
        return function (data) {
            _this.props.onPluginEvent(eventName, data);
        };
    };
    AsyncApiComponent.prototype.setupEventListeners = function () {
        var _this = this;
        var onPluginEvent = this.props.onPluginEvent;
        var pm = this.state.pm;
        if (!onPluginEvent)
            return;
        PLUGINEVENTS.forEach(function (event) {
            pm === null || pm === void 0 ? void 0 : pm.on(event, _this.handler(event));
        });
    };
    AsyncApiComponent.prototype.cleanupEventListeners = function () {
        var _this = this;
        var pm = this.state.pm;
        PLUGINEVENTS.forEach(function (event) {
            pm === null || pm === void 0 ? void 0 : pm.off(event, _this.handler(event));
        });
    };
    AsyncApiComponent.prototype.registerPlugins = function () {
        var _this = this;
        var plugins = this.props.plugins;
        var pm = this.state.pm;
        plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
            try {
                pm === null || pm === void 0 ? void 0 : pm.register(plugin);
                _this.registeredPlugins.add(plugin.name);
                _this.propsPlugins.add(plugin.name);
            }
            catch (error) {
                console.error("Failed to register plugin ".concat(plugin.name, ":"), error);
                pm === null || pm === void 0 ? void 0 : pm.emit(PLUGINEVENTS[1], {
                    pluginName: plugin.name,
                });
            }
        });
    };
    AsyncApiComponent.prototype.updatePlugins = function (prevPlugins, newPlugins) {
        var _this = this;
        var pm = this.state.pm;
        var prevPluginMap = new Map((prevPlugins !== null && prevPlugins !== void 0 ? prevPlugins : []).map(function (p) { return [p.name, p]; }));
        var newPluginMap = new Map((newPlugins !== null && newPlugins !== void 0 ? newPlugins : []).map(function (p) { return [p.name, p]; }));
        prevPluginMap.forEach(function (_plugin, name) {
            if (!newPluginMap.has(name) && _this.propsPlugins.has(name)) {
                try {
                    pm === null || pm === void 0 ? void 0 : pm.unregister(name);
                    _this.registeredPlugins.delete(name);
                    _this.propsPlugins.delete(name);
                }
                catch (error) {
                    console.error("Failed to unregister plugin ".concat(name, ":"), error);
                }
            }
        });
        newPluginMap.forEach(function (plugin, name) {
            if (!prevPluginMap.has(name)) {
                try {
                    pm === null || pm === void 0 ? void 0 : pm.register(plugin);
                    _this.registeredPlugins.add(name);
                    _this.propsPlugins.add(name);
                }
                catch (error) {
                    console.error("Failed to register plugin ".concat(name, ":"), error);
                    pm === null || pm === void 0 ? void 0 : pm.emit(PLUGINEVENTS[1], {
                        pluginName: name,
                    });
                }
            }
        });
    };
    AsyncApiComponent.prototype.updateState = function (schema) {
        var _a;
        var parsedSpec = SpecificationHelpers.retrieveParsedSpec(schema);
        if (!parsedSpec) {
            this.setState({ asyncapi: undefined });
            return;
        }
        this.setState({ asyncapi: parsedSpec });
        (_a = this.state.pm) === null || _a === void 0 ? void 0 : _a.updateContext({ schema: parsedSpec });
    };
    return AsyncApiComponent;
}(Component));
export default AsyncApiComponent;
//# sourceMappingURL=Standalone.js.map